import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AdminService} from '../admin.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', '../login/login.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  email: string;

  constructor(private adminService: AdminService,
              private router: Router) {
    this.email = '';
  }

  ngOnInit(): void {}

  forgotPassword() {
    this.router.navigate(['/login'], {}).then();
  }
}
